// extracted by mini-css-extract-plugin
export default {"fullHeightAdminApp":"YY3FgUo1qntP__HVvhSK__fullHeightAdminApp___"};